import { useState } from "react";
import { Copy, Check, Download, ArrowLeft } from "lucide-react";
import { Logo } from "./Logo";

const POSTS = [
  {
    file: "/instagram/post-01.png",
    formato: "Carosello (copertina)",
    titolo: "Presentazione",
    nota: "Usala come prima slide del carosello di presentazione. Quando hai foto vere, aggiungile come slide successive.",
    caption: `Diamo luce e anima ai tuoi momenti più rari. ✨

Siamo LMserviceevent: noleggiamo e installiamo scenografie luminose per matrimoni ed eventi in tutta Italia.

→ Fari a batteria 100% wireless (zero cavi a vista)
→ Catenarie vintage e cieli stellati
→ Allestimenti natalizi chiavi in mano
→ Installazione certificata

📩 Preventivo gratuito in 24h — link in bio

#noleggioluci #allestimentimatrimonio #luminarie #weddingitaly #matrimonio2026 #weddingplanneritalia #lucievento #allestimentieventi`,
  },
  {
    file: "/instagram/post-02.png",
    formato: "Reel / Copertina",
    titolo: "Prima/Dopo",
    nota: "Copertina del reel prima/dopo: filma la location spenta e poi accesa. Intanto puoi pubblicarla come post singolo.",
    caption: `La differenza non la fa la location. La fa la luce. 💡

Fari a batteria: 14 ore di autonomia, zero cavi sul prato, colore caldo 2700K.

Salva questo post se stai organizzando un evento ✨
📩 Preventivo in 24h — link in bio

#primadopo #weddinglighting #matrimonioitalia #faribatteria #uplighting #weddinginspiration`,
  },
  {
    file: "/instagram/post-03.png",
    formato: "Foto singola",
    titolo: "Dettaglio Catenarie",
    nota: "Primo piano festoon: perfetta come terzo riquadro della griglia di lancio.",
    caption: `2200K. La temperatura colore delle serate che non si dimenticano. 🌇

Le nostre catenarie vintage con lampadine a filamento: fino a 500 metri di atmosfera, modulabili su ogni location.

📩 info@lmserviceevent.com
📱 WhatsApp 339 279 3678

#catenarie #festoonlights #luminarievintage #matrimonioestivo #weddingdecor`,
  },
  {
    file: "/instagram/post-04.png",
    formato: "Carosello educativo (copertina)",
    titolo: "5 Errori Illuminazione",
    nota: "Sfondo con spazio vuoto: aggiungi il titolo '5 errori che rovinano l'illuminazione del tuo matrimonio' con Canva o direttamente da Instagram.",
    caption: `Li abbiamo visti tutti, e li risolviamo tutti. 🛠

1. Fari freddi 6000K da cantiere
2. Cavi sul prato (pericolosi e brutti in foto)
3. Dimenticare il taglio torta
4. Nessuna luce sul viale d'ingresso
5. Fai-da-te senza piano B pioggia

Salva il carosello e mandalo a chi si sposa nel 2026 💍
Per il punto 5: i nostri fari sono IP65, la pioggia non ci ferma.

📩 Preventivo gratuito — link in bio

#consiglimatrimonio #weddingtips #sposa2026 #organizzarematrimonio`,
  },
  {
    file: "/instagram/post-05.png",
    formato: "Reel / Copertina",
    titolo: "Backstage Montaggio",
    nota: "Copertina del reel timelapse di montaggio. Testo sul video: '3.000 punti luce. 4 ore di lavoro. 30 secondi per te.'",
    caption: `Quello che gli ospiti vedono: magia.
Quello che c'è dietro: squadra, planimetrie e collaudi. ⚡

Installazione chiavi in mano = tu pensi solo a goderti la festa.

#backstage #cielostellato #fairylights #weddingproduction #eventdesign`,
  },
  {
    file: "/instagram/post-06.png",
    formato: "Foto singola (stagionale)",
    titolo: "Natale",
    nota: "Da pubblicare da novembre. Ideale anche come copertina carosello con le foto dei tuoi allestimenti natalizi.",
    caption: `A Natale la tua facciata può diventare un biglietto da visita. 🎄

Illuminazioni esterne e interne, alberi fino a 6 metri già addobbati, schiaccianoci giganti: progettiamo, installiamo e a gennaio smontiamo tutto noi.

Per ville, hotel, ristoranti e vetrine. Prenota il sopralluogo entro ottobre 📩

#luminarienatalizie #alberodinatale #schiaccianoci #addobbinatalizi #natale2026`,
  },
  {
    file: "/instagram/post-07.png",
    formato: "Grafica testimonianza",
    titolo: "Recensione Cliente",
    nota: "Sfondo bokeh scuro: sovrapponi il testo della recensione con Canva o Instagram (font serif chiaro).",
    caption: `"Hanno trasformato il giardino della villa in un posto che non riconoscevo. Alle 2 di notte gli ospiti non volevano andare via."
— Giulia & Marco 💛

Grazie per la fiducia. Il prossimo evento potrebbe essere il tuo.
📩 Link in bio

#recensioni #sposifelici #testimonianza #matrimoniovilla`,
  },
  {
    file: "/instagram/post-08.png",
    formato: "Reel / Copertina",
    titolo: "Momento Clou",
    nota: "Copertina del reel del momento clou (ingresso sposi, taglio torta). Testo sul video: 'Il momento in cui tutti alzano il telefono.'",
    caption: `Il momento in cui tutti alzano il telefono. 🎇

Scenografie di luce pensate per il momento che conta: ingresso sposi, taglio torta, primo ballo.

📩 Raccontaci il tuo evento — link in bio

#tagliotorta #weddingcake #momentowow #weddingreel #matrimonio2026`,
  },
  {
    file: "/instagram/post-09.png",
    formato: "Foto singola",
    titolo: "La Squadra",
    nota: "Chiude la griglia di lancio con il lato umano: professionisti al lavoro prima dell'evento.",
    caption: `Dietro ogni luce c'è una persona che l'ha posizionata, puntata e collaudata. 👷‍♂️✨

Squadra LMserviceevent. Fornitura + installazione, in tutta Italia.
Il tuo evento merita professionisti, non improvvisazioni.

📱 339 279 3678
📩 info@lmserviceevent.com

#team #eventiprofessionali #serviceeventi #dietrolequinte`,
  },
];

const PostCard = ({ post, index }) => {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    await navigator.clipboard.writeText(post.caption);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <article
      data-testid={`kit-post-${index + 1}`}
      className="grid md:grid-cols-2 gap-0 border border-amber-500/15 bg-[#231e16] overflow-hidden"
    >
      <div className="relative aspect-square">
        <img src={post.file} alt={post.titolo} loading="lazy" className="w-full h-full object-cover" />
        <span className="absolute top-4 left-4 text-[10px] font-mono uppercase tracking-[0.2em] px-3 py-1.5 bg-[#181410]/85 backdrop-blur border border-amber-500/25 text-amber-300">
          Post {index + 1} — {post.formato}
        </span>
      </div>
      <div className="p-6 sm:p-8 flex flex-col">
        <h3 className="text-2xl font-serif text-[#FBF9F5]">{post.titolo}</h3>
        <p className="mt-2 text-xs text-stone-500 leading-relaxed">{post.nota}</p>
        <pre className="mt-4 flex-1 text-sm text-stone-300 leading-relaxed whitespace-pre-wrap font-sans bg-[#181410] border border-amber-500/10 p-4 max-h-64 overflow-y-auto">
          {post.caption}
        </pre>
        <div className="mt-4 flex gap-3">
          <button
            data-testid={`kit-copy-caption-${index + 1}`}
            onClick={copy}
            className="flex-1 inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full bg-amber-400 text-[#181410] text-sm font-medium hover:bg-amber-300 transition-colors min-h-[44px]"
          >
            {copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}
            {copied ? "Copiata!" : "Copia didascalia"}
          </button>
          <a
            data-testid={`kit-download-image-${index + 1}`}
            href={post.file}
            download={`lmserviceevent-post-${String(index + 1).padStart(2, "0")}.png`}
            className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full border border-amber-500/30 text-amber-300 text-sm hover:bg-amber-400/10 transition-colors min-h-[44px]"
          >
            <Download className="w-4 h-4" />
            Immagine
          </a>
        </div>
      </div>
    </article>
  );
};

export const KitSocial = () => (
  <div data-testid="kit-social-page" className="min-h-screen bg-[#181410]">
    <header className="border-b border-amber-500/15 backdrop-blur-xl bg-[#181410]/90 sticky top-0 z-40">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 h-[72px] flex items-center justify-between">
        <Logo />
        <a
          data-testid="kit-back-home"
          href="/"
          className="inline-flex items-center gap-2 text-sm text-stone-300 hover:text-amber-300 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" /> Torna al sito
        </a>
      </div>
    </header>

    <main className="max-w-6xl mx-auto px-5 sm:px-8 py-16">
      <p className="text-xs font-mono uppercase tracking-[0.25em] text-amber-400/90 mb-4">Kit Social</p>
      <h1 className="text-3xl sm:text-4xl font-serif text-[#FBF9F5] tracking-tight">
        9 contenuti pronti per @lmserviceevent
      </h1>
      <p className="mt-4 max-w-2xl text-sm sm:text-base text-stone-400 leading-relaxed">
        Ogni scheda ha immagine e didascalia pronta: scarica l'immagine, copia la didascalia e pubblica.
        Le immagini sono generate con AI in stile coerente col brand — appena hai foto dei tuoi
        allestimenti reali, sostituiscile: i contenuti autentici convertono sempre meglio.
        Per i reel trovi la copertina pronta: il video lo giri al prossimo montaggio.
      </p>

      <div className="mt-12 space-y-8">
        {POSTS.map((p, i) => (
          <PostCard key={p.file} post={p} index={i} />
        ))}
      </div>
    </main>
  </div>
);
